import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { hotRanking } from "@/mocks/gossip";

export default function HotRanking() {
  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          index="01"
          title="今日热议榜"
          subtitle="按讨论热度排出的当日话题，每一条都只给结论和一句摘要，想深挖再往评论区走。"
          meta="每 30 分钟更新一次"
        />

        <div className="mt-9 flex flex-col gap-3 md:mt-12">
          {hotRanking.map((item, idx) => (
            <Reveal key={item.rank} delay={idx * 60}>
              <a
                href="#discuss"
                className={`group flex cursor-pointer flex-col gap-4 rounded-lg border p-4 transition-colors md:flex-row md:items-center md:gap-6 md:p-5 ${
                  item.rank <= 3
                    ? "border-primary-200 bg-primary-50/50 hover:border-primary-300"
                    : "border-background-200 bg-background-50 hover:border-secondary-300"
                }`}
              >
                <div className="flex items-center gap-4 md:gap-5">
                  <span
                    className={`w-8 shrink-0 text-center font-display text-2xl font-black leading-none md:w-10 md:text-3xl ${
                      item.rank <= 3 ? "text-primary-500" : "text-background-400"
                    }`}
                  >
                    {String(item.rank).padStart(2, "0")}
                  </span>
                  <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md md:h-[74px] md:w-[74px]">
                    <img
                      src={item.thumb}
                      alt={`${item.title} 的话题配图`}
                      title={`${item.title} 骚女qq 话题热议`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">
                      {item.tag}
                    </span>
                    {item.rank <= 3 ? (
                      <span className="inline-flex items-center gap-1 rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-900">
                        <i className="ri-fire-line" />
                        正在升温
                      </span>
                    ) : null}
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.summary}
                  </p>
                </div>

                <div className="flex shrink-0 items-center gap-5 border-t border-background-200 pt-3 md:border-l md:border-t-0 md:pl-6 md:pt-0">
                  <div>
                    <p className="text-[11px] text-foreground-500">热度</p>
                    <p className="text-sm font-bold text-primary-600">{item.heat}</p>
                  </div>
                  <div>
                    <p className="text-[11px] text-foreground-500">评论</p>
                    <p className="text-sm font-bold text-foreground-800">{item.comments}</p>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}